import { render, staticRenderFns } from "./OrderStatusTable.vue?vue&type=template&id=896c47d0"
import script from "./OrderStatusTable.vue?vue&type=script&lang=js"
export * from "./OrderStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports